import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const IntrusionDetection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Advanced Security & Intelligence Systems" 
      subtitle="Comprehensive security solutions powered by AI and machine learning technologies, delivering end-to-end protection for critical infrastructure, borders, and secure facilities."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Innovative Mobile & RF Cyber Solutions</h2>
            <p>
              Advanced mobile and radio frequency (RF) cybersecurity systems for tactical, homeland, and border security applications. Our solutions empower military, paramilitary, and law enforcement agencies with real-time intelligence, surveillance, secure communication infrastructure, and comprehensive protection against modern threats.
            </p>
            
            <div className="capabilities-section" style={{marginTop: '32px'}}>
              <h3 style={{fontSize: '1.8rem', fontWeight: '700', marginBottom: '24px', color: '#1a1a1a', textAlign: 'center'}}>
                Core Security Capabilities
              </h3>
              
              <div className="capabilities-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '24px', marginBottom: '32px'}}>
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2ZM17 18H7V6H17V18Z" fill="#495057"/>
                      <circle cx="12" cy="19" r="1" fill="#495057"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Mobile Detection & Control</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Advanced mobile phone detection, denial, and precise location tracking systems</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM9 6C9 4.34 10.34 3 12 3S15 4.34 15 6V8H9V6ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15S13.1 13 12 13 10 13.9 10 15 10.9 17 12 17Z" fill="#495057"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Secure Communications</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Private, encrypted communication networks for sensitive environments and operations</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L13.09 8.26L16 7L14.74 10.91L21 12L14.74 13.09L16 17L13.09 15.74L12 22L10.91 15.74L8 17L9.26 13.09L3 12L9.26 10.91L8 7L10.91 8.26L12 2Z" fill="#495057"/>
                      <circle cx="12" cy="12" r="3" fill="none" stroke="#495057" strokeWidth="1.5"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>ISR Systems</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Intelligence, Surveillance & Reconnaissance with real-time data fusion</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3L2 12H5V20H19V12H22L12 3ZM7 18V10.5L12 5.69L17 10.5V18H15V13H9V18H7Z" fill="#495057"/>
                      <rect x="10" y="14" width="4" height="4" fill="#495057"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Infrastructure Protection</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Comprehensive protection for prisons, meetings, and critical infrastructure</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L12.9 5.5L16.24 3.76L15.07 7.17L19 7L16.5 9.5L19 12L15.07 16.83L16.24 20.24L12.9 18.5L12 22L11.1 18.5L7.76 20.24L8.93 16.83L5 17L7.5 14.5L5 12L8.93 7.17L7.76 3.76L11.1 5.5L12 2Z" fill="none" stroke="#495057" strokeWidth="1.5"/>
                      <circle cx="12" cy="12" r="3" fill="#495057"/>
                      <path d="M12 8V12L14.5 14.5" stroke="white" strokeWidth="1" fill="none"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Emergency Networks</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Rapid deployment emergency communication for disaster response operations</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1ZM12 3.18L5 6.3V11.22C5 15.54 8.07 19.43 12 20.81C15.93 19.43 19 15.54 19 11.22V6.3L12 3.18ZM15.5 10L14.09 8.59L10.5 12.17L8.91 10.59L7.5 12L10.5 15L15.5 10Z" fill="#495057"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Border Security</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Multi-layered border and critical infrastructure intrusion detection systems</p>
                </div>
              </div>

            </div>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>MP2DS: Mobile Phone Presence Detection System</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Comprehensive mobile phone detection, denial, and location systems designed to eliminate unauthorized communications in high-security environments. Our solutions provide complete mobile-free zones while enabling secure private networks for authorized personnel.
                  </p>
                  
                  <div className="info-section">
                    <h4>Prison Communication Guard (PCG)</h4>
                    <p><strong>Secure, Mobile-Free Correctional Facilities</strong></p>
                    <ul>
                      <li>100% Mobile Signal Denial: Completely blocks all mobile services within the defined perimeter</li>
                      <li>Accurate Device Identification: Detects and identifies every mobile device inside the premises</li>
                      <li>Precise Location Tracking: Locates devices with up to 1-meter accuracy using our Mobile Device Locator System (MDLS)</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Secure Meeting Guard (SMG)</h4>
                    <p><strong>No Spying. No Eavesdropping. Fully Secured Ops Rooms.</strong></p>
                    <ul>
                      <li>Total Mobile Blocking: Guaranteed 100% detection and denial of mobile phone use</li>
                      <li>Anti-Espionage Protection: Comprehensive jamming to eliminate risks of surveillance</li>
                      <li>Private Secure Network: Allows official voice and SMS use while blocking internet/data access</li>
                      <li>Modular & Scalable: Customizable to different room sizes and applications</li>
                      <li>Intelligent Monitoring: Detects SIM or device changes in real time</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Entrance Point Mobile Phone Detection System (EPMPDS)</h4>
                    <p><strong>Protect Entry Points from Mobile-Based Espionage</strong></p>
                    <ul>
                      <li>Automated Identity Verification: Confirms each person entering the premises and detects devices</li>
                      <li>RF Sanitization: Maintains a mobile-free, sanitized zone inside secure areas</li>
                      <li>Real-Time Threat Alerts: Identifies suspicious activity immediately</li>
                      <li>Integrated Walkthrough Detection: Detects, locates, and identifies phones during entry</li>
                      <li>Government Database Integration: Compatible with national ID and intelligence systems</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Critical Infrastructure Communication Guard (CICG)</h4>
                    <p><strong>Shielding Strategic Sites from Communication-Based Threats</strong></p>
                    <ul>
                      <li>Secure Entry/Exit Points: Identity checks at key access points to prevent unauthorized intrusion</li>
                      <li>Restricted Communications: Denies mobile access both inside and near critical infrastructure zones</li>
                      <li>Real-Time Surveillance: Provides live monitoring and intelligence via integrated command and control software</li>
                      <li>System Integration: Seamlessly links with government databases and national security systems</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Anti-Drug Trafficking Detection System</h4>
                    <p><strong>Track Smugglers on Land, Sea, or Air Using Mobile Signals</strong></p>
                    <ul>
                      <li>Wide-Area Detection: Detects mobile phone activity of traffickers on land, sea, and coastal waters—even swimmers</li>
                      <li>Advanced ID Recognition: Captures IMSI/IMEI data to identify known traffickers and new recruits</li>
                      <li>Intelligent Analytics: Maps mobile usage patterns to track movements and organizational behavior</li>
                      <li>Use Cases: Maritime drug interdiction, arms smuggling, coastal surveillance, and seaport perimeter control</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Secure Visitor Management System (SVMS)</h4>
                    <p><strong>Controlled Mobile Access at Reception and Entry Points</strong></p>
                    <ul>
                      <li>Pre-Authorized Entry: Visitor verification via QR-based approval</li>
                      <li>Device Detection: Identifies disclosed and undisclosed mobile phones instantly</li>
                      <li>Time-Based Alerts: Sends automatic alerts when visitor time limits are exceeded</li>
                      <li>Next-Gen Coverage: Supports detection across 2G, 3G, 4G, 5G, and future networks</li>
                      <li>Optional Geo-Fencing: Enables location-based mobile management within defined zones</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Mansion Communication Guard (MCG)</h4>
                    <p><strong>Private and Secure Mobile Networks for Residences & Offices</strong></p>
                    <ul>
                      <li>Full Mobile Signal Denial: 100% block of all external mobile services within the premises</li>
                      <li>Complete Device Identification: Detects every phone inside the estate or facility</li>
                      <li>Precision Location: Locates devices with up to 1-meter accuracy</li>
                      <li>Private Mansion Network (MWC): Allows limited-use private mobile services (voice/SMS only, no broadband or camera)</li>
                      <li>Role-Based Access Control: Assigns device and user-specific communication permissions</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>TrueiDetect</h4>
                    <p><strong>Intelligent Mobile Screening at Immigration & Security Checkpoints</strong></p>
                    <ul>
                      <li>Real-Time Device Detection: Identifies all communication devices and their users at checkpoints and terminals</li>
                      <li>Automated ID Verification: Links device data with biometric and national identity databases</li>
                      <li>Multi-SIM Awareness: Detects all SIM cards and mobile identities in each handset</li>
                      <li>Non-Intrusive Screening: Enables full-spectrum monitoring without disrupting passenger flow</li>
                      <li>Future-Proof Design: Supports 2G to 5G+ networks and integrates with existing security systems</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>True Identity Detection at Choke Points</h4>
                    <p><strong>Ensure Identity Verification at High-Risk Transit Zones</strong></p>
                    <ul>
                      <li>100% Mobile Detection: Accurately identifies all mobile devices passing through the area</li>
                      <li>Advanced Reporting: Generates alerts and logs based on mobile identities</li>
                      <li>Access Control: Entry granted only after mobile identity verification, ensuring tighter security at defiles and vulnerable transit corridors</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Advanced Border Monitoring & Intelligence Gathering</h4>
                    <p><strong>Unified Mobile Intelligence for Customs & Border Protection</strong></p>
                    <ul>
                      <li>Comprehensive Mobile Detection: Identifies and logs every mobile device at the border</li>
                      <li>Real-Time Identity Verification: Uses network data to verify individuals instantly</li>
                      <li>Advanced Analytics: Detects suspicious patterns and potential threats using mobile intelligence</li>
                      <li>Live Monitoring: Offers a real-time operational view of border activities</li>
                      <li>Easy Deployment: Designed for fast setup, remote management, and minimal operator training</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Tactical Identity Detection in Buildings</h4>
                    <p><strong>Covert Surveillance for Law Enforcement & Homeland Security</strong></p>
                    <ul>
                      <li>Rapid Mobile Presence Detection: Identifies targets within enclosed or shielded environments</li>
                      <li>Multi-Generation Compatibility: Supports detection across 2G through 5G+ networks</li>
                      <li>Integrated Video Surveillance: Enables live visual monitoring through secure feeds</li>
                      <li>Private Tactical Networks: Provides secure voice, video, and data channels, even when public networks are down</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Foliage-Penetrating Human Detection System</h4>
                    <p><strong>Uncover Hidden Threats in Dense Terrain</strong></p>
                    <ul>
                      <li>100% Detection Rate: Proven performance in dense foliage and rugged landscapes</li>
                      <li>Vital Asset Protection: Detects human movement near strategic sites and installations</li>
                      <li>Flexible Deployment: Available in manpack, tripod, vehicle-mounted, drone, balloon, and helicopter configurations</li>
                      <li>Rapid Setup: Quick deployment time for mission-critical scenarios</li>
                      <li>Integrated Situational Awareness: Seamlessly connects to command and control systems for real-time updates</li>
                      <li>Mobile Device Tracking: Locates and tracks phones with up to 1-meter accuracy</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Cross-Border Mobile Intelligence Collection (Part 1)</h4>
                    <p><strong>Detect Foreign Phones Inside National Borders</strong></p>
                    <ul>
                      <li>High-Fidelity Detection: Identifies every foreign mobile phone operating within domestic territory</li>
                      <li>1-Meter Precision: Locates each detected device with high accuracy</li>
                      <li>Persistent Monitoring: Ideal for ongoing surveillance in border areas and buffer zones</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Cross-Border Mobile Intelligence Collection (Part 2)</h4>
                    <p><strong>Mobile Signal Intelligence Across the Borderline</strong></p>
                    <ul>
                      <li>Total Localization & ID Capture: Provides real-time detection and identity mapping of mobile phone users across the border</li>
                      <li>Remote & Scalable: Easy to deploy and operate; fully remotely manageable</li>
                      <li>Live Cross-Border Monitoring: Maintains continuous surveillance and intelligence logging for advanced situational awareness</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/mp2ds_mobile_phone_presence_detection_system.png" 
                    alt="Mobile Phone Detection Technology" 
                    onClick={() => openLightbox('/images/mp2ds_mobile_phone_presence_detection_system.png', 'Mobile Phone Detection Technology')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Multi-Layered Border & Perimeter Intrusion Detection</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Advanced multi-layered fused border and perimeter intrusion detection systems with intelligent surveillance capabilities, providing comprehensive protection for critical infrastructure, national borders, and strategic facilities with precision accuracy and minimal false alarms.
                  </p>
                  
                  <div className="info-section">
                    <h4>Intelligent Border Security</h4>
                    <ul>
                      <li>Real-time intelligence gathering with multi-sensor data fusion</li>
                      <li>High-precision intrusion detection capabilities</li>
                      <li>Advanced border monitoring and intelligence collection</li>
                      <li>Smart protection for creeks and riverine borders</li>
                      <li>Integration with command and control networks</li>
                      <li>Rapidly deployable ISR systems for challenging terrains</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Perimeter Protection Systems</h4>
                    <ul>
                      <li>Multi-layered sensor fusion with vibration detection</li>
                      <li>Radar systems (X-Band and K-Band) for comprehensive coverage</li>
                      <li>Laser fence and underground sensor networks</li>
                      <li>Proximity sensors and wireless monitoring capabilities</li>
                      <li>Weather-resistant all-terrain deployment options</li>
                      <li>AI-powered verification minimizing false alarms</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/multi_layered_border_perimeter_intrusion_detection.png" 
                    alt="Border & Perimeter Detection Systems" 
                    onClick={() => openLightbox('/images/multi_layered_border_perimeter_intrusion_detection.png', 'Border & Perimeter Detection Systems')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Counter Drone Measures</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Integrated drone detection and jamming systems providing comprehensive protection against unauthorized drone threats through advanced RF-based detection and active countermeasures.
                  </p>
                  
                  <div className="info-section">
                    <h4>Detection & Identification</h4>
                    <ul>
                      <li>RF-based drone detection and identification systems</li>
                      <li>Integrated omni-directional and directional detection</li>
                      <li>Networked drone detection capabilities</li>
                      <li>Real-time threat classification and alerting</li>
                      <li>Multiple deployment configurations available</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Jamming & Countermeasures</h4>
                    <ul>
                      <li>Wearable, handheld, and portable jamming systems</li>
                      <li>Vehicle-mounted and fixed installation options</li>
                      <li>High-power directional and omni-directional jammers</li>
                      <li>Integrated detection and jamming capabilities</li>
                      <li>Networked counter-drone defense systems</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1473968512647-3e447244af8f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Counter-Drone Systems" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1473968512647-3e447244af8f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Counter-Drone Systems')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Secure Private Mobile Broadband Communication</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Secure, resilient, and rapidly deployable 4G/LTE networks for defense, disaster management, rural connectivity, and strategic operations. Our solutions function independently of public telecom operators and are optimized for rugged conditions with advanced tactical capabilities.
                  </p>
                  
                  <div className="info-section">
                    <h4>Rural Mobile Broadband Network</h4>
                    <p><strong>Turnkey 4G/LTE Network for Unconnected Regions</strong></p>
                    <ul>
                      <li>Rapid deployment fully operational within 3 days</li>
                      <li>Solar-powered operation with self-sustaining networks and minimal environmental impact</li>
                      <li>Remote network management optimized for low operational costs (OPEX)</li>
                      <li>Comprehensive coverage delivering 4G/LTE voice, internet, and IPTV services</li>
                      <li>Reliable infrastructure with all-weather, carrier-grade equipment and high fault tolerance</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Tailor-Made Secure Mobile Network</h4>
                    <p><strong>Private LTE Network for Tactical & Strategic Missions</strong></p>
                    <ul>
                      <li>Advanced tactical communications with secure voice, video, and data across units</li>
                      <li>Real-time situational awareness enabling field-to-command coordination</li>
                      <li>Flexible connectivity supporting V-SAT and microwave backhaul to HQ</li>
                      <li>Multi-platform deployment mountable on vehicles, helicopters, drones, or worn as manpacks</li>
                      <li>Security features including remote disabling of compromised devices</li>
                      <li>Ruggedized build designed for harsh weather and extreme conditions</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Situational Awareness System (SAS)</h4>
                    <p><strong>Smart Devices & Accessories for Frontline Teams</strong></p>
                    <ul>
                      <li>SAS handset with secure device running specialized applications</li>
                      <li>Extended power with battery pack providing up to 8 hours of operation</li>
                      <li>Noise-canceling headset for hands-free communication</li>
                      <li>Wrist-worn and chest-mounted handsets for hands-free field use</li>
                      <li>Helmet-mounted camera for live video streaming during operations</li>
                      <li>Biometric monitoring with real-time vitals (heartbeat, SpO2) integration</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>SAS Handset: Secure Tactical Communication Device</h4>
                    <ul>
                      <li>AES-256 encryption for secure voice, video, and data transmission</li>
                      <li>Full duplex communication with high-quality audio and video</li>
                      <li>Anti-jamming capabilities operating reliably under hostile signal interference</li>
                      <li>Compact & durable with shock-resistant, water-sealed housing</li>
                      <li>Advanced positioning system with GAGAN and foreign GPS support</li>
                      <li>Extended battery life up to 15 hours of continuous operation</li>
                      <li>User-friendly interface with simple, intuitive controls</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>ResQMobil: Emergency Communication Network</h4>
                    <p><strong>Life-Saving Mobile Network for Disaster Relief Operations</strong></p>
                    <ul>
                      <li>Instant 4G network setup deployable within 30 minutes</li>
                      <li>Human detection identifying signs of life in rubble, mines, or collapsed structures</li>
                      <li>Victim communication sending SMS to relay health status or location</li>
                      <li>Precise victim location tracking</li>
                      <li>Deployment options available in manpack, vehicle-mounted, fixed-site, or airborne versions</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Instant Secure Mobile Broadband Network</h4>
                    <p><strong>Rapid Deployment Network for Emergency and Remote Missions</strong></p>
                    <ul>
                      <li>Self-contained system including internal battery and antenna in single manpack unit</li>
                      <li>Fast activation operational within 10 minutes</li>
                      <li>MNO-independent functioning without relying on public mobile operators</li>
                      <li>Remote connectivity supporting V-SAT and microwave links to central command</li>
                      <li>Multi-platform mounting compatible with manpack, vehicle, drone, and helicopter</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Advanced Communication Accessories</h4>
                    <ul>
                      <li>Crypto Bluetooth headset with stealth communication and anti-eavesdropping technology</li>
                      <li>Push-to-encrypt voice features preventing illegal recording and tracking</li>
                      <li>Smart walkie-talkie with real-time multilingual translation capabilities</li>
                      <li>Position hiding gateway with GPS camouflage and dynamic location masking</li>
                      <li>Identity protection against IMSI, IMEI, and MAC address tracking</li>
                      <li>File-based encryption for stored data with secure charging solutions</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/secure_private_mobile_broadband_communication.png" 
                    alt="Secure Mobile Communication Systems" 
                    onClick={() => openLightbox('/images/secure_private_mobile_broadband_communication.png', 'Secure Mobile Communication Systems')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Custom RF Cyber Solutions</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Specialized custom RF cyber solutions including malicious activity detection systems, long-range wireless connectivity, and advanced forensics capabilities for cellular mobile devices and RF communications.
                  </p>
                  
                  <div className="info-section">
                    <h4>Advanced RF Detection & Analytics</h4>
                    <ul>
                      <li>Malicious Activity Detection & Forensics System (MADS)</li>
                      <li>RF cellular packet data analytics and intelligence</li>
                      <li>Custom mobile device forensics capabilities</li>
                      <li>Advanced threat detection and classification systems</li>
                      <li>Real-time RF spectrum monitoring and analysis</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Specialized Communication Solutions</h4>
                    <ul>
                      <li>Extended-range Wi-Fi solutions for remote connectivity</li>
                      <li>Custom RF communication system development</li>
                      <li>Specialized detection systems for unique requirements</li>
                      <li>Tailored security solutions for specific operational needs</li>
                      <li>Integration with existing security infrastructure</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Privacy & Anonymity Solutions</h4>
                    <ul>
                      <li>Secure VPN-enabled gateways for real-time location masking</li>
                      <li>Global position spoofing and anonymity protection</li>
                      <li>Digital footprint masking for high-risk operations</li>
                      <li>Advanced tracking prevention and counter-surveillance</li>
                      <li>Secure gateway solutions for sensitive travel and operations</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/custom_rf_cyber_solutions.png" 
                    alt="Custom RF Cyber Solutions" 
                    onClick={() => openLightbox('/images/custom_rf_cyber_solutions.png', 'Custom RF Cyber Solutions')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Our Advanced Security Solutions?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  We deliver comprehensive security solutions that combine cutting-edge technology with proven reliability. Our systems are designed for mission-critical applications where performance and security cannot be compromised, backed by extensive global deployment experience and in-house development capabilities.
                </p>
                
                <div className="info-section">
                  <h4>Complete End-to-End Systems</h4>
                  <p>We conceive, design, and manufacture all systems in-house, owning all technologies and intellectual property. Complete system integration from design to deployment with lifetime upgrades and comprehensive support.</p>
                </div>
                
                <div className="info-section">
                  <h4>AI & Machine Learning Driven Solutions</h4>
                  <p>Advanced artificial intelligence and machine learning technologies power our hardware and software systems, enhancing reliability, reducing false alarms, and improving threat detection accuracy across all security domains.</p>
                </div>
                
                <div className="info-section">
                  <h4>Proven Global Deployment Experience</h4>
                  <p>Extensive international deployment experience across diverse terrains and challenging environments, with successful implementations in multiple countries across various continents and operational scenarios.</p>
                </div>
                
                <div className="info-section">
                  <h4>State-of-the-Art R&D and Manufacturing</h4>
                  <p>Standards-compliant R&D laboratory with high-tech manufacturing and field-testing facilities. Extensive track record in design, development, and successful deployment of innovative security solutions.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    Our integrated security ecosystem provides multi-layered protection utilizing advanced AI-driven technologies, ensuring optimal performance in the most demanding environments while maintaining complete system ownership and control.
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                  alt="Advanced Security Excellence" 
                  onClick={() => openLightbox('https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Advanced Security Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Secure Your Critical Infrastructure</h3>
            <p>Ready to deploy comprehensive security solutions? Contact our advanced technology specialists to discuss your specific security requirements and explore our integrated protection systems.</p>
            <a href="/contact" className="btn immigration-btn-primary">Get Security Consultation</a>
          </div>

          <div style={{marginTop: '40px', padding: '20px', background: 'rgba(240,240,240,0.8)', borderRadius: '12px', textAlign: 'center'}}>
            <p style={{margin: '0', fontSize: '0.9rem', color: '#666', fontStyle: 'italic'}}>
              Advanced security solutions delivered in partnership with Shyam VNL Corporate
            </p>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default IntrusionDetection;